import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import colors from '../../../scss/colors';
import ExpandIcon from '../Icons/ExpandIcon';

const Accordion = styled((props) => <MuiAccordion disableGutters elevation={0} square {...props} />)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.down('1024')]: {
    boxShadow: '0px 0px 10px 0px rgba(61, 107, 149, 0.10)'
  },
  '&.MuiPaper-root.MuiAccordion-root': {
    backgroundColor: colors.WHITE,
    borderRadius: '0 0 6px 6px'
  },
  '&:before': {
    display: 'none'
  }
}));

const AccordionSummary = styled((props) => <MuiAccordionSummary expandIcon={<ExpandIcon />} {...props} />)(() => ({
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(180deg)'
  }
}));

const AccordionDetails = styled(MuiAccordionDetails)(() => ({}));

const ExpandedPanel = ({ title, isExpanded = false, children }) => {
  const [expanded, setExpanded] = useState(isExpanded);

  return (
    <Accordion data-testid="expandedpanel" expanded={expanded} onChange={() => setExpanded((prev) => !prev)}>
      <AccordionSummary>
        <Typography
          sx={{ color: colors.NAVY_BLUE, fontStyle: 'normal', fontWeight: 325, fontSize: '14px', lineHeight: 'normal' }}
        >
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};

export default ExpandedPanel;
